import React, {useContext} from 'react';
import {AppContext} from '../../../AppModule/Context';
import './messageCue.css';

const MessageCue = (props) => {
  const context = useContext(AppContext);
  return (
    <React.Fragment>
      {context.showChatCue && (
        <div
          className={`et-hc-ind-img-cue ${
            props.isWidgetFooter ? 'et-hc-ind-img-cue-footer-widget' : ''
          } ${
            props.isWidgetOtVideo ? 'et-hc-ind-img-cue-otvideo-widget' : ''
          } ${props.isPersonalPage ? 'et-hc-ind-img-cue-otvideo-personal' : ''}
           ${
             props.isExpertHomeOtVideo
               ? 'et-hc-ind-img-cue-otvideo-expert-home'
               : ''
           }`}>
          {context.chatMessageCueCounter}
        </div>
      )}
    </React.Fragment>
  );
};

export default MessageCue;
